export const SuppliersEndpoints = {
    list: () => '/suppliers/list',
    details: () => '/suppliers/details',
    picker: () => '/suppliers/picker',
    create: () => '/suppliers',
    update: (id: string) => `/suppliers/${id}`,
    delete: (id: string) => `/suppliers/${id}`,
    payments: (id: string) => `/suppliers/${id}/payments`,
    deletePayment: (id: string, paymentId: string) =>
        `/suppliers/${id}/payments/${paymentId}`,
    statement: (id: string) => `/suppliers/${id}/statement`,
    archive: (id: string) => `/suppliers/${id}/archive`,
    unarchive: (id: string) => `/suppliers/${id}/unarchive`,
};
